
import { defineComponent, PropType  } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import FtlAdditionalService from '@/modules/FTLModule/components/FtlAdditionalService/index.vue'

import { StockDeliveryNoteT } from '@/core/types/orders.types'

export default defineComponent({
    components: {
        TheButton,
        FtlAdditionalService,
    },
    props: {
        stockDeliveryNote: {
            type: Object as PropType<StockDeliveryNoteT>,
            required: true,
        },
        isUploadingScan: {
            type: Boolean,
            default: false,
        },
        isPrintingInvoice: {
            type: Boolean,
            default: false,
        }
    },
    emits: [
        'upload-scan',
        'print-invoice',
    ],
    setup(props, { emit }) {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        const uploadScan = () => {
            if (props.isUploadingScan) return
            emit('upload-scan', { ...props.stockDeliveryNote })
        }

        const printInvoice = () => {
            if (props.isPrintingInvoice) return
            emit('print-invoice')
        }

        return {
            formatAmount,
            uploadScan,
            printInvoice
        }
    }
})
